import { FilesFolders } from 'constants/files-folders-enum';
import { useApiUploadActions } from 'hooks/upload-actions';
import { useTranslation } from 'react-i18next';

import { DocumentUploadModal } from 'components/DocumentUploadModal/DocumentUploadModal';

export const CandidateCheckDocumentUploadModal = ({
  candidate,
  checkType,
  visible,
  onUpdate = () => {},
  onClose = () => {},
}) => {
  const { t } = useTranslation();
  const { signUpload, createUpload, deleteUpload } = useApiUploadActions();

  const handleUpload = async uploadData => {
    await createUpload(uploadData);
    onUpdate();
  };

  return (
    <DocumentUploadModal
      visible={visible}
      onClose={onClose}
      onUpload={handleUpload}
      title={t('admin.candidate.check.uploadSupportingDocumentCheckType', {
        title: checkType?.title,
      })}
      selectedType={checkType?.slug}
      onlyUpload={true}
      companyId={candidate?.company_id}
      modelParams={{
        candidate_id: candidate?.id,
        company_id: candidate?.company_id,
      }}
      metadata={{
        check_type: checkType?.slug,
      }}
      bucketFolder={FilesFolders.CandidatesApplicationDocuments}
      signUpload={signUpload}
      deleteUpload={deleteUpload}
    />
  );
};
